import React from "react";
import PropTypes from "prop-types";

const RetakeWarnings = (retakeType, retakeCount, prepareTime, answerTime) => {
  if (retakeType === "LIMIT_PER_QUESTION") {
    return (
      <p className="text-gray-700">
        You will have {prepareTime} seconds to prepare for each question, and{" "}
        {answerTime} seconds to answer. If you aren&apos;t satisfied with your
        response, you have {retakeCount} retake{retakeCount !== 1 ? "s" : ""}{" "}
        per question.
      </p>
    );
  } else if (retakeType === "LIMIT_PER_INTERVIEW") {
    return (
      <p className="text-gray-700">
        You will have {prepareTime} seconds to prepare for each question, and{" "}
        {answerTime} seconds to answer. If you aren&apos;t satisfied with your
        response, you have {retakeCount} total retake
        {retakeCount !== 1 ? "s" : ""} for the entire interview.
      </p>
    );
  } else if (retakeType === "UNLIMITED") {
    return (
      <p className="text-gray-700">
        You will have as long as needed to prepare for each question, and{" "}
        {answerTime} seconds to answer. If you aren&apos;t satisfied with your
        response, you can retake as many times as you want.
      </p>
    );
  }
};

RetakeWarnings.propTypes = {
  retakeType: PropTypes.number.isRequired,
  retakeCount: PropTypes.number,
  prepareTime: PropTypes.number,
  answerTime: PropTypes.number.isRequired,
};

export default RetakeWarnings;
